import { TextProps } from '@chakra-ui/react';
import { Text } from 'components/UI';
import { specialFont } from 'constants/theme';

const SidebarText = ({ children }: TextProps) => (
  <Text as="span" color="inherit" fontSize="lg" letterSpacing={3} fontFamily={specialFont}>
    {children}
  </Text>
);

export default SidebarText;
